import React from "react";
import { motion } from "framer-motion";
import { PRESS_LOGOS } from "../data/content";

// Kept exported name for backward compatibility with App.js
export const FindUs = () => null;

export const Press = () => {
  return (
    <section
      id="press"
      data-testid="press-section"
      className="relative py-32 md:py-48 bg-[#14100D] text-[#EFE7D6] overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-8 md:px-16">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="grid md:grid-cols-12 gap-16 items-start"
        >
          <div className="md:col-span-5">
            <div className="flex items-center gap-6 mb-10">
              <span className="counter">07 — Press</span>
              <span className="w-16 hairline-strong h-px inline-block" />
              <span className="overline">Press &amp; Investors</span>
            </div>
            <h2 className="display-tight text-4xl md:text-6xl">
              The room is
              <br />
              <span className="italic text-[#DCCFB4]">already talking.</span>
            </h2>
            <p className="font-body text-lg md:text-xl text-[#DCCFB4]/80 mt-8 leading-[1.5] max-w-md">
              Media inquiries, retail partnerships, and investor briefings —
              we'd love to share the deck.
            </p>
            <div className="mt-10">
              <button
                onClick={() =>
                  document
                    .getElementById("inquire")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                className="btn-primary"
                data-testid="press-cta"
              >
                Request the Deck
              </button>
            </div>
          </div>

          <div className="md:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3">
              {PRESS_LOGOS.map((p, i) => (
                <motion.div
                  key={p}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.06 }}
                  className={`px-6 py-10 flex items-center justify-center text-center border-[#EFE7D6]/12 ${
                    i % 3 !== 2 ? "border-r" : ""
                  } ${i < PRESS_LOGOS.length - (PRESS_LOGOS.length % 3 || 3) ? "border-b" : ""}`}
                  data-testid={`press-logo-${i}`}
                >
                  <span className="font-body text-lg md:text-xl text-[#DCCFB4]/70 leading-tight">
                    {p}
                  </span>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
